<template>
  <v-dialog
    max-width="700px"
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-form>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Ver Consultorio</v-toolbar-title>
        </v-toolbar>

        <v-card-title class="mb-4">{{ nombreProfesional }}</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="6" md="9">
              <v-select
                :items="consultorios"
                item-text="nombre"
                item-value="idConsultorio"
                menu-props="auto"
                label="Consultorio"
                hide-details
                prepend-icon="mdi-account"
                v-model="idConsultorio"
                dense
                no-data-text="No hay Consultorios configurados"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.stop="modificarConsultorio"
            >Guardar</v-btn
          >
          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import axios from "../../axios-auth.js";

export default {
  data() {
    return {
      consultorios: [],
      idConsultorio: null,
    };
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.cargarConsultorios();
          this.buscarDatosProfesional();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  props: ["visible", "nombreProfesional", "idProfesional"],
  methods: {
    cargarConsultorios() {
      const filtrosData = {
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Profesional/GetConsultoriosDeInst", {
          params: {
            idInstitucion: filtrosData.idInstitucion,
          },
        })
        .then((response) => {
          if (response.data != null && response.data != "")
            self.consultorios = response.data;
          else self.consultorios = [];
        })
        .catch((error) => {});
    },
    buscarDatosProfesional() {
      const idprofesional = this.idProfesional;
      let self = this;

      axios
        .get("/Profesional/GetProfesionalPorId?", {
          params: {
            idprofesional: idprofesional,
          },
        })
        .then((response) => {
          self.idConsultorio = response.data.idConsultorio;
        })
        .catch((error) => {});
    },
    modificarConsultorio() {
      this.$swal({
        title: "Modificar Consultorio",
        text: "¿Desea modificar el consultorio del profesional",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosConsultorio = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idProfesional: this.idProfesional,
            idConsultorio: this.idConsultorio,
          };
          let self = this;
          axios
            .post(
              "/Profesional/ModificarConsultorioDeProfesional",
              datosConsultorio
            )
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Consultorio modificado exitosamente",
                vm: self,
              });
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El consultorio no puedo ser modificado",
                vm: this,
              });
            });
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
